<template>
  <v-form v-model="valid" ref="mainForm">
    <opq-date-picker
      code="date-naissance"
      is-birthdate
      v-model="sas.sasEtudiantCandidat.dateDeNaissance"
      :live="{ endpoint: '/sas-etudiant-candidat/', cle: 1910, fileId: sas.sasEtudiantCandidat.id }"
    ></opq-date-picker>

    <adresse-personnelle :carteAffaire="sas.adressePersonnelle" two-columns></adresse-personnelle>
  </v-form>
</template>

<script>
import AdressePersonnelle from "@/components/FormParts/AdressePersonnelle"
import FormSimple from "@/mixins/FormSimple"
export default {
  mixins: [FormSimple],
  components: { AdressePersonnelle },
  props: {
    sas: { type: Object }
  }
}
</script>

<style>
</style>